import type { FC } from "react";
import { Container, Row } from "react-grid-system";
import Subtitle from "../atoms/typography/Subtitle";
import { theme } from "../../theme";
import { HorizontalSpacer } from "../atoms/Spacers";
import { useTranslation } from "react-i18next";
import Body from "../atoms/typography/Body";
import { PageEatenIllustration } from "../atoms/illustrations/PageEatenIllustration";

const UnauthorizedPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Container>
        <HorizontalSpacer spacing={4} />
        <Subtitle color={theme.colors.primary} textalign="center">
          Unauthorized
        </Subtitle>
        <HorizontalSpacer spacing={2} />
        <Body textalign="center">{t("errors.unauthorizedDescription")}</Body>
        <HorizontalSpacer spacing={2} />
        <Row justify="center">
          <PageEatenIllustration />
        </Row>
      </Container>
    </div>
  );
};

export default UnauthorizedPage;
